module.exports = __webpack_public_path__ + "img/ardi-logo-wh.97af95d1.svg";